import PageWrapper from "./PageWrapper";
import Container from "react-bootstrap/Container";
import React, {useEffect, useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import Palette from "../../util/Palette";
import {isMobile} from "react-device-detect";
import Session from "../../models/Session";
import Strings from "../../util/Strings";
import SessionCard from "../reusable/SessionCard";
import {useHistory, Link, useParams} from "react-router-dom";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Cities from "../../asset/constants/Cities";
import Checkbox from "@material-ui/core/Checkbox";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import PresenceForm from "../../models/PresenceForm";

export default function PresentForm(props) {

    const [upcomingSession, setUpcomingSession] = useState([])
    const [isSessionInDatabase, setSessionInDatabase] = useState(true);
    const [email, setEmail] = useState('');
    const [fullName, setFullName] = useState('');
    const [classCode, setClassCode] = useState(null);
    const [className, setClassName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const presenceFormModel = new PresenceForm();

    const history = useHistory()
    let { class_code } = useParams();

    const handleSubmit = async () => {
        if (!fullName) {
            showSnackBar('Harap isi nama Anda', 'warning')
        } else if (!email) {
            showSnackBar('Harap isi alamat surel Anda', 'warning')
        } else if (!validateEmail(email)) {
            showSnackBar('Harap masukan alamat surel yang valid', 'warning')
        } else if (!phoneNumber) {
            showSnackBar('Harap isi nomor telepon Anda', 'warning')
        } else if (!classCode) {
            showSnackBar('Harap pilih kelas', 'warning')
        } else {
            try {
                const result = await presenceFormModel.create({
                    class_code: classCode,
                    class_name: className,
                    email,
                    full_name: fullName,
                    phone_num: phoneNumber
                })

                reset()

                if (result.id) {
                    showSnackBar('Presensi Anda berhasil kami rekam!', 'success')
                }
            } catch (e) {
                console.log(e)

                showSnackBar('Kesalahan Terjadi!', 'warning')
            }
        }
        // else if() {
        //
        // }
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    useEffect(() => {
        fetchUpcomingSessions()
    }, [])

    const fetchUpcomingSessions = async () => {
        try {

            const result = await new Session().getUpcomingForDropdown()

            if(class_code){

                try{
                    const session = await new Session().getByCode(class_code);

                    console.log("found ", session)

                    const isSameDay = new moment(session.start_time).format("DD MMMM YYYY") === new moment(session.end_time).format("DD MMMM YYYY");

                    setClassCode(class_code)
                    setClassName(session.name + ` (${new moment(session.start_time).format("DD MMMM YYYY")}${!isSameDay ? '--' + new moment(session.end_time).format("DD MMMM YYYY") : ''})`)

                    return
                }catch(e){
                    console.log("class not found")
                }

            }

            let formattedSession = result.map((obj, key) => {
                console.log(obj)

                const isSameDay = new moment(obj.start_time).format("DD MMMM YYYY") === new moment(obj.end_time).format("DD MMMM YYYY");

                return {
                    value: obj.code,
                    label: obj.name + ` (${new moment(obj.start_time).format("DD MMMM YYYY")}${!isSameDay ? '--' + new moment(obj.end_time).format("DD MMMM YYYY") : ''})`,
                }
            })

            console.log(formattedSession)

            setUpcomingSession(formattedSession)

        } catch (e) {
            console.log(e)
        }

    }

    const [snackBarProp, setSnackBarProp] = useState({});

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const showSnackBar = (message, severity) => {
        setSnackBarProp({
            open: true,
            message,
            severity
        })
    }

    const reset = () => {
        setEmail("")
        setFullName("")
        setClassCode(null)
        setClassName("")
        setPhoneNumber("")
    }

    return <PageWrapper
        headerShy={false}
        headerActive={'book-store'}>

        <Snackbar
            anchorOrigin={{vertical: "top", horizontal: "center"}}
            open={snackBarProp.open} autoHideDuration={6000}
            onClose={() => {
                setSnackBarProp({
                    open: false
                })
            }}>
            <Alert severity={snackBarProp.severity}>
                {snackBarProp.message}
            </Alert>
        </Snackbar>

        <Container style={{marginBottom: '60px'}} fluid>

            <Container>
                <Row style={{
                    marginTop: isMobile ? 0 : "4em",
                    fontFamily: 'OpenSans-Bold'
                }}>

                </Row>

                <Row style={{
                    marginTop: "2em",
                }}>
                    <Container fluid style={{
                        maxWidth: 900,
                    }}>
                        <Row>

                            <Col
                                style={{
                                    color: Palette.PRIMARY,
                                    fontSize: "2em",
                                    fontFamily: 'OpenSans-Bold',
                                    textAlign: "center"
                                }}
                                md={12}>
                                Formulir Presensi
                                <br/>
                            </Col>
                            <Col md={12}>
                                <Form>
                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                        <Form.Label>Nama</Form.Label>
                                        <Form.Control
                                            value={fullName}
                                            onChange={(e) => setFullName(e.target.value)}
                                            style={{fontSize: "1em"}} type="text" placeholder=""/>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{Strings.login_pop_up.email} (<i>Email</i>)</Form.Label>
                                        <Form.Control
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            style={{fontSize: "1em"}} type="email" placeholder=""/>
                                    </Form.Group>

                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                        <Form.Label>Nomor Telepon</Form.Label>
                                        <Form.Control
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            style={{fontSize: "1em"}} type="text" placeholder=""/>
                                    </Form.Group>

                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                        <Form.Label
                                            style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <div style={{flex: 1}}>
                                                Kelas
                                            </div>

                                            {/*<div>*/}
                                            {/*    <Checkbox*/}
                                            {/*        checked={!isSessionInDatabase}*/}
                                            {/*        onChange={() => setSessionInDatabase(!isSessionInDatabase)}*/}
                                            {/*        inputProps={{ 'aria-label': 'primary checkbox' }}*/}
                                            {/*    />*/}

                                            {/*    <small>Kelas tidak ada pada daftar</small>*/}
                                            {/*</div>*/}
                                        </Form.Label>
                                        <div style={{width: "100%"}}>
                                            {isSessionInDatabase ?
                                                <Select
                                                    isDisabled={class_code && classCode && className}
                                                    value={{value: classCode, label: className}}
                                                    onChange={(session) => {
                                                        setClassCode(session.value)
                                                        setClassName(session.label)
                                                    }}
                                                    placeholder={"Pilih Kelas"}
                                                    options={upcomingSession}
                                                    style={{
                                                        display: "flex", width: "100%"
                                                    }}
                                                /> :
                                                <Form.Control
                                                    style={{fontSize: "1em"}} type="text" placeholder=""/>
                                            }
                                        </div>

                                    </Form.Group>
                                </Form>
                            </Col>
                            <Col md={12} style={{
                                display: "flex",
                                justifyContent: "center"
                            }}>
                                <Button
                                    style={{
                                        paddingLeft: 36,
                                        paddingRight: 36
                                    }}
                                    onClick={handleSubmit}>
                                    Kirim
                                </Button>
                            </Col>

                        </Row>
                    </Container>
                </Row>

            </Container>

        </Container>

    </PageWrapper>

}
